import React from 'react';

import type { RecursiveMenuProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import RecursiveMenuItemTitleWithHeading from './ItemTitleWithHeading';

export type RecursiveMenuWithHeadingProps<P extends RecursiveMenuProps = RecursiveMenuProps> = P & {
  withHeading?: boolean;
};

const recursiveMenuWithHeading = <P extends RecursiveMenuProps = RecursiveMenuProps>(
  BaseMenu: React.FC<P>,
) => (props: RecursiveMenuWithHeadingProps<P>) => {
    const { withHeading = false, ...restProps } = props;

    return (
      <BaseMenu
        {...restProps as P}
        MenuItemTitle={withHeading ? RecursiveMenuItemTitleWithHeading : undefined}
      />
    );
  };

export default recursiveMenuWithHeading;
